<app-toast-messages />
<app-save-modal [visible]="globalService.saving()" />
<div class="app-container">
  <app-navbar class="width-100" />
  <div class="router-container">
    <router-outlet></router-outlet>
  </div>
</div>
